export function useOrganizationApi() {
  const { authStore, ...extended } = useAuthApi();
  const organizationStore = useOrganizationStore();

  const currentOrganization = computed(
    () => organizationStore.currentOrganization,
  );

  async function awaitUserAndOrganizationLoaded(
    fn?: (value?: OrganizationInfo) => unknown,
  ): Promise<OrganizationInfo | undefined> {
    if (!authStore.isAuthed || currentOrganization.value) {
      return Promise.resolve(currentOrganization.value).then((v) => {
        fn?.(v);
        return v;
      });
    }
    await authStore.awaitUserLoaded();

    return new Promise((resolve) => {
      const stop = watch(
        currentOrganization,
        (value) => {
          if (value) {
            stop();
            resolve(value);
            fn?.(value);
          }
        },
        { flush: "sync" },
      );
    });
  }

  return {
    ...extended,
    authStore,
    organizationStore,
    currentOrganization,
    awaitUserAndOrganizationLoaded,
  };
}
